module.exports = __webpack_public_path__ + "img/3939784_0030.879fe557.jpg";